  document.addEventListener('DOMContentLoaded', function(){

  document.querySelectorAll('[data-section-id]').forEach(function(section){

    initCollectionGrid(section);

  });

});

function initCollectionGrid(section){

  var excludedCollections = (section.getAttribute('data-excluded-collections') || '')
    .split(',').map(function(s){ return s.trim().toLowerCase(); }).filter(Boolean);
  var excludedBrands = (section.getAttribute('data-excluded-brands') || '')
    .split(',').map(function(s){ return s.trim().toLowerCase(); }).filter(Boolean);

  // Category allow-list (set via schema "Allowed category handles")
  var allowedCategoriesRaw = section.getAttribute('data-allowed-categories') || '';
  var allowedCategories = allowedCategoriesRaw
  .split(',')
  .map(function(s){
    var parts = s.split('::');

    return {
      label: (parts[0] || '').trim(),
      handle: (parts[1] || '').trim()
    };
  })
  .filter(function(x){
    return x.handle;
  });

  // handle -> display title (real Shopify collection titles)
  var categoryMap = {};
  try {
    categoryMap = JSON.parse(section.getAttribute('data-category-map') || '{}');
  } catch (e) { categoryMap = {}; }
  var vendorMap = {};
  try {
    vendorMap = JSON.parse(section.getAttribute('data-vendor-map') || '{}');
  } catch (e) { vendorMap = {}; }

  // HSA/FSA tag — normalized (lowercase, trimmed)
  var hsafsaTag = (section.getAttribute('data-hsafsa-tag') || 'hsafsa').trim().toLowerCase();

  var filterBar = section.querySelector('[data-filter-bar]');
  var filterButtons = section.querySelectorAll('[data-filter]');
  var hsaToggleBtn = section.querySelector('[data-hsa-toggle]');
var grid = section.querySelector('.cfg-grid');

  var perPage = parseInt(section.getAttribute('data-per-page')) || 12;
  var totalProducts = parseInt(section.getAttribute('data-total-products')) || 0;
  var currentlyShowing = perPage;
  var productIndex = section.querySelectorAll('.cfg-product-card').length;
  var mobileOverlay = section.querySelector('.cfg-mobile-overlay')
  var priceTimeout;
  var bodyMenus = {};
  var hsaActive = false;
  var activeCategoryFilters = [];
  var activeTagFilters = [];
  var activeFiltersWrap = section.querySelector('[data-active-filters]');
var activeFiltersList = section.querySelector('.cfg-active-filters__list');
var clearAllBtn = section.querySelector('[data-clear-all]');

  function isMobile(){ return window.innerWidth <= 768; }

  // ──────────────────────────────────────────
  // Card binding (autoship card script — same as carousel section)
  // ──────────────────────────────────────────
  function bindCard(card){
    var inner = card.querySelector('[data-pl-fa-card]');
    if (!inner || inner.dataset.plFaBound === 'true') return;
    inner.dataset.plFaBound = 'true';

    var toggleBtns = inner.querySelectorAll('[data-pl-fa-toggle]');
    var freqSelect = inner.querySelector('[data-pl-fa-freq]');
    var badgeEl = inner.querySelector('[data-pl-fa-save-badge]');
    var atc = inner.querySelector('[data-pl-fa-atc]');
    var autoshipPriceEl = inner.querySelector('[data-pl-fa-autoship-price]');
    var autoshipLabelEl = inner.querySelector('[data-pl-fa-autoship-label]');

    function getMode(){ return inner.dataset.mode || 'onetime'; }
    function setMode(m){ inner.dataset.mode = m; }

    function getActiveSellingPlan(){
      if (getMode() !== 'autoship') return null;
      if (freqSelect) {
        var opt = freqSelect.options[freqSelect.selectedIndex];
        if (!opt) return null;
        return {
          id: opt.value,
          price: parseInt(opt.dataset.price, 10),
          priceFormatted: opt.dataset.priceFormatted,
          discountPct: parseInt(opt.dataset.discountPct, 10) || 0,
          label: opt.dataset.label || ''
        };
      }
      if (!inner.dataset.sellingPlanId) return null;
      return {
        id: inner.dataset.sellingPlanId,
        price: parseInt(inner.dataset.spPrice, 10),
        priceFormatted: inner.dataset.spPriceFormatted,
        discountPct: parseInt(inner.dataset.spDiscountPct, 10) || 0,
        label: inner.dataset.spLabel || ''
      };
    }

    function updateBadge(){
      if (!badgeEl) return;
      var sp = getActiveSellingPlan();
      if (sp && sp.discountPct > 0) badgeEl.textContent = 'Save ' + sp.discountPct + '%';
    }
    function updateAutoshipDisplay(){
      var sp = getActiveSellingPlan();
      if (!sp) return;
      if (autoshipPriceEl) autoshipPriceEl.textContent = sp.priceFormatted;
      if (autoshipLabelEl) autoshipLabelEl.textContent = sp.label;
    }

    toggleBtns.forEach(function(btn){

  if (btn.disabled) return;

  btn.addEventListener('click', function(){
        setMode(btn.dataset.plFaToggle);
        toggleBtns.forEach(function(b){ b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        updateBadge();
      });
    });
    if (freqSelect) {
      freqSelect.addEventListener('change', function(){ updateAutoshipDisplay(); updateBadge(); });
    }
    if (atc) {
      atc.addEventListener('click', function(){
        if (atc.disabled) return;
        atc.dataset.loading = 'true';
        var sp = getActiveSellingPlan();
        var item = { id: parseInt(inner.dataset.variantId, 10), quantity: 1 };
        if (getMode() === 'autoship' && sp) item.selling_plan = parseInt(sp.id, 10);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [item] })
        })
        .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function(data){
          var unitPrice = (getMode() === 'autoship' && sp ? sp.price : parseInt(inner.dataset.onetimePrice, 10)) / 100;
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
              items: [{
                item_id: inner.dataset.productId,
                item_variant: inner.dataset.variantId,
                quantity: 1,
                price: unitPrice,
                affiliation: 'pl-collection-autoship-grid',
item_list_name: section.dataset.collectionTitle || '',
                selling_plan: getMode() === 'autoship' && sp ? sp.id : null
              }]
            }
          });
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
        })
        .catch(function(){ window.location.href = '/cart'; })
        .finally(function(){ setTimeout(function(){ delete atc.dataset.loading; }, 250); });
      });
    }
  }

  function bindAllCards(){
    section.querySelectorAll('.cfg-product-card').forEach(bindCard);
  }
  bindAllCards();

  // ──────────────────────────────────────────
  // Filter UI
  // ──────────────────────────────────────────
  function getOrCreateBodyMenu(filterType){
    if (bodyMenus[filterType]) return bodyMenus[filterType];
    var sourceMenu = section.querySelector('[data-filter-menu="' + filterType + '"]');
    if (!sourceMenu) return null;

    var clone = sourceMenu.cloneNode(true);

clone.classList.add('active');

clone.removeAttribute('data-filter-menu');
clone.removeAttribute('style');

clone.className = 'cfg-body-menu';

clone.setAttribute(
  'data-body-menu',
  filterType
);

if (filterType === 'brand') {

  clone.insertAdjacentHTML(
    'beforeend',
    `
      <div class="cfg-body-menu__footer">

        <button
          type="button"
          class="cfg-body-menu__apply">

          Apply Filters

        </button>

      </div>
    `
  );

}

document.body.appendChild(clone);

    clone.querySelectorAll('input[type="checkbox"]').forEach(function(cloneInput){

  cloneInput.addEventListener('change', function(){

    var orig = sourceMenu.querySelector(
      'input[name="' + cloneInput.name + '"][value="' + cloneInput.value + '"]'
    );

    if (orig) {
      orig.checked = cloneInput.checked;
    }

    if (filterType !== 'brand') {

      applyFilters();

    }

  });

});
var applyBtn =
  clone.querySelector('.cfg-body-menu__apply');

if (applyBtn) {

  applyBtn.addEventListener('click', function(){

    applyFilters();

    closeAllDropdowns();

  });

}
    clone.querySelectorAll('input[type="radio"]').forEach(function(cloneInput){
      cloneInput.addEventListener('change', function(){
        sourceMenu.querySelectorAll('input[name="' + cloneInput.name + '"]').forEach(function(r){ r.checked = false; });
        var orig = sourceMenu.querySelector('input[name="' + cloneInput.name + '"][value="' + cloneInput.value + '"]');
        if (orig) orig.checked = true;
        applyFilters();
        setTimeout(closeAllDropdowns, 200);
      });
    });
    clone.querySelectorAll('input[name="cfg-price-min"], input[name="cfg-price-max"]').forEach(function(cloneInput){
      cloneInput.addEventListener('input', function(){
        var orig = sourceMenu.querySelector('input[name="' + cloneInput.name + '"]');
        if (orig) orig.value = cloneInput.value;
        clearTimeout(priceTimeout);
        priceTimeout = setTimeout(applyFilters, 500);
      });
    });

    bodyMenus[filterType] = clone;
    return clone;
  }

  // HSA/FSA toggle pill
  if (hsaToggleBtn) {
    hsaToggleBtn.addEventListener('click', function(){
      hsaActive = !hsaActive;
hsaToggleBtn.classList.toggle('active', hsaActive);
hsaToggleBtn.setAttribute('aria-pressed', hsaActive ? 'true' : 'false');
      applyFilters();
    });
  }

  function closeAllDropdowns(){
    section.querySelectorAll('.cfg-filter-btn').forEach(function(btn){ btn.classList.remove('active'); });
    section.querySelectorAll('.cfg-filter-menu').forEach(function(menu){ menu.classList.remove('active'); });
    Object.keys(bodyMenus).forEach(function(key){
      var bm = bodyMenus[key];
      bm.classList.remove('active');
      setTimeout(function(){ if (!bm.classList.contains('active')) bm.style.display = 'none'; }, 320);
    });
    if (mobileOverlay) mobileOverlay.classList.remove('active');
    document.body.classList.remove('cfg-menu-open');
  }

  filterButtons.forEach(function(button){
    button.addEventListener('click', function(e){
      e.stopPropagation();
      var filterType = this.getAttribute('data-filter');
      var wasActive = this.classList.contains('active');
      closeAllDropdowns();
      if (!wasActive) {
        this.classList.add('active');
        if (isMobile()) {
          var bodyMenu = getOrCreateBodyMenu(filterType);
          if (bodyMenu) {
            bodyMenu.style.display = 'block';
            requestAnimationFrame(function(){
              requestAnimationFrame(function(){ bodyMenu.classList.add('active'); });
            });
          }
          if (mobileOverlay) mobileOverlay.classList.add('active');
          document.body.classList.add('cfg-menu-open');
        } else {
          var srcMenu = section.querySelector('[data-filter-menu="' + filterType + '"]');
          if (srcMenu) srcMenu.classList.add('active');
        }
      }
    });
  });

  document.addEventListener('click', function(e){
    if (!e.target.closest('.cfg-body-menu') && !e.target.closest('.cfg-filter-dropdown')) {
      closeAllDropdowns();
    }
  });
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeAllDropdowns);


  function titleCaseFromHandle(handle){
  return (handle || '')
    .split('-')
    .map(function(w){
      return w.charAt(0).toUpperCase() + w.slice(1);
    })
    .join(' ');
}

function rebuildBrandFilter(){
  var menu = section.querySelector('[data-filter-menu="brand"]');
  if (!menu) return;

  var selected = Array.from(
    menu.querySelectorAll('input[name="cfg-brand"]:checked')
  ).map(function(i){ return i.value; });

  var vendors = new Map();

  getAllCards().forEach(function(card){
    var vendorHandle = (card.getAttribute('data-vendor') || '').trim();
    if (!vendorHandle) return;

    if (excludedBrands.indexOf(vendorHandle) !== -1) return;
var vendorName = (card.getAttribute('data-vendor-name') || '').trim();
   vendors.set(
  vendorHandle,
  vendorName
);
  });

  var sorted = Array.from(vendors.entries()).sort(function(a,b){
    return a[1].localeCompare(b[1]);
  });

  menu.innerHTML = '';

  sorted.forEach(function(entry){
    var handle = entry[0];
    var label = entry[1];
    var checked = selected.indexOf(handle) !== -1 ? 'checked' : '';

    menu.insertAdjacentHTML('beforeend', `
      <label>
        <input type="checkbox" name="cfg-brand" value="${handle}" ${checked}>
        ${label}
      </label>
    `);
  });

  menu.querySelectorAll('input[name="cfg-brand"]').forEach(function(input){
    input.addEventListener('change', applyFilters);
  });
}

  // ──────────────────────────────────────────
  // Lazy fetch all remaining products for full-collection filtering
  // ──────────────────────────────────────────
  function fetchRemainingProducts(){
    if (totalProducts <= 50) return;
    var loadingEl = section.querySelector('.cfg-loading-indicator')
    if (loadingEl) loadingEl.classList.add('active');

    var collectionUrl = section.getAttribute('data-collection-url');
    var totalPagesNeeded = Math.ceil(totalProducts / 50);
    var pagesToFetch = [];
    for (var p = 2; p <= totalPagesNeeded; p++) pagesToFetch.push(p);

    var fetchPromises = pagesToFetch.map(function(pageNum){
var sectionId = section.dataset.sectionId;
var url = collectionUrl + '?page=' + pageNum + '&sections=' + sectionId;
      return fetch(url).then(function(r){ return r.json(); }).then(function(data){
        return { pageNum: pageNum, html: data[sectionId] };
      });
    });

    Promise.all(fetchPromises).then(function(results){
      results.sort(function(a,b){ return a.pageNum - b.pageNum; });
      var existingIds = new Set();
      section.querySelectorAll('.cfg-product-card').forEach(function(card){
        existingIds.add(card.getAttribute('data-product-id'));
      });
      results.forEach(function(result){
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = result.html;
        tempDiv.querySelectorAll('.cfg-product-card').forEach(function(card){
          var pid = card.getAttribute('data-product-id');
          if (existingIds.has(pid)) return;
          existingIds.add(pid);
          productIndex++;
          card.setAttribute('data-product-index', productIndex);
          card.classList.add('cfg-product-card--hidden');
          card.style.display = 'none';
          grid.appendChild(card);
          bindCard(card);
        });
      });
if (loadingEl) loadingEl.classList.remove('active');

rebuildBrandFilter();

applyFilters();
    }).catch(function(err){
      console.error('CFG fetch error', err);
      if (loadingEl) loadingEl.classList.remove('active');
    });
  }

  function getAllCards(){ return section.querySelectorAll('.cfg-product-card'); }

  function hasActiveFilters(){
  var a = section.querySelectorAll('input[name="cfg-availability"]:checked').length;
  var c = activeCategoryFilters.length;
  var b = section.querySelectorAll('input[name="cfg-brand"]:checked').length;
  var t = activeTagFilters.length;
  var mn = section.querySelector('input[name="cfg-price-min"]');
  var mx = section.querySelector('input[name="cfg-price-max"]');
  return a > 0 || c > 0 || b > 0 || t > 0 || (mn && mn.value) || (mx && mx.value) || hsaActive;
}

  function sortProducts(sortType){
var cards = Array.from(
  grid.querySelectorAll('.cfg-product-card')
);  
    cards.sort(function(a, b){
      switch (sortType) {
        case 'price-ascending': return parseFloat(a.getAttribute('data-price')) - parseFloat(b.getAttribute('data-price'));
        case 'price-descending': return parseFloat(b.getAttribute('data-price')) - parseFloat(a.getAttribute('data-price'));
        case 'title-ascending': return (a.getAttribute('data-title')||'').localeCompare(b.getAttribute('data-title')||'');
        case 'title-descending': return (b.getAttribute('data-title')||'').localeCompare(a.getAttribute('data-title')||'');
        case 'created-ascending': return parseInt(a.getAttribute('data-created')) - parseInt(b.getAttribute('data-created'));
        case 'created-descending': return parseInt(b.getAttribute('data-created')) - parseInt(a.getAttribute('data-created'));
        default: return 0;
      }
    });
   cards.forEach(function(card, i){
      grid.appendChild(card);
      card.setAttribute('data-product-index', i + 1);
    });
  }

  function cardHasTag(card, tag){
    if (!tag) return true;
    var raw = (card.getAttribute('data-tags') || '').toLowerCase();
    if (!raw) return false;
    var list = raw.split(',').map(function(t){ return t.trim(); });
    return list.indexOf(tag) !== -1;
  }
function renderActiveFilterPills(){

  if (!activeFiltersWrap || !activeFiltersList) return;

  activeFiltersList.innerHTML = '';

  var pills = [];

  var availabilityInputs =
    Array.from(
      section.querySelectorAll('input[name="cfg-availability"]:checked')
    );

  availabilityInputs.forEach(function(input){

    pills.push({
      type: 'availability',
      value: input.value,
      label:
        input.value === 'in-stock'
          ? 'In Stock'
          : 'Out of Stock'
    });

  });

  var brandInputs =
    Array.from(
      section.querySelectorAll('input[name="cfg-brand"]:checked')
    );

brandInputs.forEach(function(input){

    var label =
      input.closest('label')
        ?.textContent
        ?.trim() || input.value;

    pills.push({
      type: 'brand',
      value: input.value,
      label: label
    });

  });

  activeTagFilters.forEach(function(tag){
    var matchingPill = section.querySelector('[data-tag-pill][data-tag-value="' + tag + '"]');
    var tagLabel = matchingPill ? (matchingPill.textContent || '').trim() : tag;
    pills.push({ type: 'tag', value: tag, label: tagLabel });
  });

  var sortInput =
    section.querySelector('input[name="cfg-sort"]:checked');

  if (sortInput) {

    var sortLabel =
      sortInput.closest('label')
        ?.textContent
        ?.trim();

    if (
      sortInput.value &&
      sortInput.value !== 'manual'
    ) {

      pills.push({
        type: 'sort',
        value: sortInput.value,
        label: sortLabel || 'Sorted'
      });

    }

  }

  var minPrice =
    section.querySelector('input[name="cfg-price-min"]')?.value;

  var maxPrice =
    section.querySelector('input[name="cfg-price-max"]')?.value;

  if (minPrice || maxPrice) {

    var label = 'Price: ';

    if (minPrice) label += '$' + minPrice;

    label += ' – ';

    if (maxPrice) {
      label += '$' + maxPrice;
    } else {
      label += '∞';
    }

    pills.push({
      type: 'price',
      value: 'price',
      label: label
    });

  }

 if (!pills.length) {

  activeFiltersWrap.hidden = true;

} else {

  activeFiltersWrap.hidden = false;

}


  pills.forEach(function(pill){

   var pillEl = document.createElement('div');

pillEl.className = 'cfg-active-filter-pill';

pillEl.innerHTML = `
  <span class="cfg-active-filter-pill__label">
    ${pill.label}
  </span>

  <button
    type="button"
    class="cfg-active-filter-pill__remove">
    ×
  </button>
`;

pillEl
  .querySelector('.cfg-active-filter-pill__remove')
  .addEventListener('click', function(){

    removeFilterPill(
      pill.type,
      pill.value
    );

  });

activeFiltersList.appendChild(pillEl);

  });

}
function removeFilterPill(type, value){

  if (type === 'availability') {

    section.querySelectorAll(
      'input[name="cfg-availability"]'
    ).forEach(function(input){

      if (input.value === value) {
        input.checked = false;
      }

    });

  }

  if (type === 'category') {

  activeCategoryFilters =
    activeCategoryFilters.filter(function(x){
      return x !== value;
    });

  section
    .querySelectorAll('[data-category-pill]')
    .forEach(function(pill){

      if (
        pill.getAttribute('data-category') === value
      ) {
        pill.classList.remove('active');
      }

    });

}
  if (type === 'brand') {

    section.querySelectorAll(
      'input[name="cfg-brand"]'
    ).forEach(function(input){

      if (input.value === value) {
        input.checked = false;
      }

    });

  }

  if (type === 'sort') {

  section.querySelectorAll(
    'input[name="cfg-sort"]'
  ).forEach(function(input){

    input.checked = false;

  });

  window.__cfgLastSort = null;

  location.reload();

}

  if (type === 'price') {

    var min =
      section.querySelector(
        'input[name="cfg-price-min"]'
      );

    var max =
      section.querySelector(
        'input[name="cfg-price-max"]'
      );

    if (min) min.value = '';
    if (max) max.value = '';

  }

  if (type === 'hsa') {

    hsaActive = false;

    if (hsaToggleBtn) {

      hsaToggleBtn.setAttribute(
        'aria-pressed',
        'false'
      );

    }

  }
  if (type === 'tag') {
  activeTagFilters = activeTagFilters.filter(function(x){ return x !== value; });
  section.querySelectorAll('[data-tag-pill]').forEach(function(pill){
    if (pill.getAttribute('data-tag-value') === value) pill.classList.remove('active');
  });
}

  applyFilters();

}
if (clearAllBtn) {

  clearAllBtn.addEventListener('click', function(){

    section.querySelectorAll(
      'input[type="checkbox"], input[type="radio"]'
    ).forEach(function(input){

      input.checked = false;

    });

    section.querySelectorAll(
      'input[name="cfg-price-min"], input[name="cfg-price-max"]'
    ).forEach(function(input){

      input.value = '';

    });

hsaActive = false;
    activeCategoryFilters = [];
    activeTagFilters = [];

    section.querySelectorAll('[data-category-pill]').forEach(function(pill){
      pill.classList.remove('active');
    });

    section.querySelectorAll('[data-tag-pill]').forEach(function(pill){
      pill.classList.remove('active');
    });

    if (hsaToggleBtn) {
      hsaToggleBtn.setAttribute('aria-pressed', 'false');
    }

    applyFilters();

  });

}
section.querySelectorAll('[data-category-pill]').forEach(function(pill){

  pill.addEventListener('click', function(){

var handle =
  (this.getAttribute('data-category') || '')
    .trim()
    .toLowerCase();
    if (activeCategoryFilters.indexOf(handle) !== -1) {
      activeCategoryFilters = activeCategoryFilters.filter(function(x){
        return x !== handle;
      });

      this.classList.remove('active');

    } else {

      activeCategoryFilters.push(handle);

      this.classList.add('active');
    }

    applyFilters();
  });

});
section.querySelectorAll('[data-tag-pill]').forEach(function(pill){
  pill.addEventListener('click', function(){
    var tag = (this.getAttribute('data-tag-value') || '').trim().toLowerCase();
    if (activeTagFilters.indexOf(tag) !== -1) {
      activeTagFilters = activeTagFilters.filter(function(x){ return x !== tag; });
      this.classList.remove('active');
    } else {
      activeTagFilters.push(tag);
      this.classList.add('active');
    }
    applyFilters();
  });
});

function resetOriginalSort(){

  var cards = Array.from(
    grid.querySelectorAll('.cfg-product-card')
  );

  cards.sort(function(a, b){

    return (
      parseInt(a.getAttribute('data-original-position')) -
      parseInt(b.getAttribute('data-original-position'))
    );

  });

  cards.forEach(function(card){

    grid.appendChild(card);

  });

}
  function applyFilters(){

  var sortVal =
    section.querySelector(
      'input[name="cfg-sort"]:checked'
    );

  if (sortVal) {

  if (
    window.__cfgLastSort !== sortVal.value
  ) {

    window.__cfgLastSort =
      sortVal.value;

    sortProducts(sortVal.value);

  }

} else if (window.__cfgLastSort) {

  window.__cfgLastSort = null;

  sortProducts('original');

}
  var cards = getAllCards();

  var availChecked =
    Array.from(
      section.querySelectorAll(
        'input[name="cfg-availability"]:checked'
      )
    ).map(function(i){

      return i.value
        .trim()
        .toLowerCase();

    });

  var catChecked =
    activeCategoryFilters.map(function(cat){

      return (cat || '')
        .trim()
        .toLowerCase();

    });

  var brandChecked =
    Array.from(
      section.querySelectorAll(
        'input[name="cfg-brand"]:checked'
      )
    ).map(function(i){

      return i.value
        .trim()
        .toLowerCase();

    });

  var priceMinEl =
    section.querySelector(
      'input[name="cfg-price-min"]'
    );

  var priceMaxEl =
    section.querySelector(
      'input[name="cfg-price-max"]'
    );

  var priceMin =
    priceMinEl && priceMinEl.value
      ? parseFloat(priceMinEl.value)
      : 0;

  var priceMax =
    priceMaxEl && priceMaxEl.value
      ? parseFloat(priceMaxEl.value)
      : Infinity;

  var isFiltering = hasActiveFilters();

  var isSortOnly =
    sortVal &&
    !availChecked.length &&
    !catChecked.length &&
    !brandChecked.length &&
    priceMin === 0 &&
    priceMax === Infinity &&
    !hsaActive;

  var visibleCount = 0;

  cards.forEach(function(card){

    var match = true;

    /* =========================
       Availability
    ========================= */

    if (availChecked.length > 0) {

      var isAvail =
        card.getAttribute('data-availability') === 'true';

      var wantIn =
        availChecked.includes('in-stock');

      var wantOut =
        availChecked.includes('out-of-stock');

      if (
        wantIn &&
        !wantOut &&
        !isAvail
      ) {

        match = false;

      }

      if (
        wantOut &&
        !wantIn &&
        isAvail
      ) {

        match = false;

      }

    }

    /* =========================
       Price
    ========================= */

    var price =
      parseFloat(
        card.getAttribute('data-price')
      ) / 100;

    if (
      price < priceMin ||
      price > priceMax
    ) {

      match = false;

    }

    /* =========================
       Categories
    ========================= */

    if (catChecked.length > 0) {

      var productCols =
        (card.getAttribute('data-collections') || '')
          .split(',')
          .map(function(col){

            return col
              .trim()
              .toLowerCase();

          })
          .filter(Boolean);

      var hasCategoryMatch =
        catChecked.some(function(cat){

          return productCols.includes(cat);

        });

      if (!hasCategoryMatch) {

        match = false;

      }

    }

    /* =========================
       Brands
    ========================= */

    if (brandChecked.length > 0) {

      var vendor =
        (card.getAttribute('data-vendor') || '')
          .trim()
          .toLowerCase();

      if (!brandChecked.includes(vendor)) {

        match = false;

      }

    }

    /* =========================
       HSA/FSA
    ========================= */

    if (hsaActive) {

      if (!cardHasTag(card, hsafsaTag)) {

        match = false;

      }

    }
    /* =========================
   Tag Pills
========================= */

if (activeTagFilters.length > 0) {
  var hasTagMatch = activeTagFilters.every(function(tag){
    return cardHasTag(card, tag);
  });
  if (!hasTagMatch) match = false;
}

    /* =========================
       Visibility
    ========================= */

   if (
      isFiltering &&
      !isSortOnly
    ) {

      if (match) {
        card.classList.remove('cfg-product-card--hidden');
        card.style.display = '';
      } else {
        card.style.display = 'none';
      }

    } else {

      var idx =
        parseInt(
          card.getAttribute('data-product-index')
        );

      if (idx <= currentlyShowing) {
        card.classList.remove('cfg-product-card--hidden');
        card.style.display = '';
      } else {
        card.style.display = 'none';
      }

    }

    if (
      card.style.display !== 'none'
    ) {

      visibleCount++;

    }

  });

  /* =========================
     Counts
  ========================= */

  var countEl =
    section.querySelector(
      '.cfg-count-number'
    );

  if (countEl) {

    countEl.textContent = visibleCount;

  }

  var showingEl =
    section.querySelector(
      '.cfg-showing-count'
    );

  if (showingEl) {

    showingEl.textContent = visibleCount;

  }

  /* =========================
     Load More
  ========================= */

  var loadMoreWrap =
    section.querySelector(
      '.cfg-load-more-wrap'
    );

  if (loadMoreWrap) {

    loadMoreWrap.style.display =
      (
        isFiltering &&
        !isSortOnly
      )
        ? 'none'
        : (
            currentlyShowing >= cards.length
              ? 'none'
              : ''
          );

  }

  renderActiveFilterPills();

}

  section.querySelectorAll('input[type="checkbox"]').forEach(function(input){
    input.addEventListener('change', applyFilters);
  });
  section.querySelectorAll('input[type="radio"]').forEach(function(input){
    input.addEventListener('change', function(){ applyFilters(); setTimeout(closeAllDropdowns, 200); });
  });
  section.querySelectorAll('input[name="cfg-price-min"], input[name="cfg-price-max"]').forEach(function(input){
    input.addEventListener('input', function(){ clearTimeout(priceTimeout); priceTimeout = setTimeout(applyFilters, 500); });
  });

  var loadMoreBtn = section.querySelector('.cfg-load-more-btn');
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', function(){
      currentlyShowing += perPage;
      applyFilters();
    });
    renderActiveFilterPills();
  }

  fetchRemainingProducts();
}